import { ProjectView, WorkspaceView } from '@lemoncloud/codes-goods-api';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const createDualStorage = () => ({
    getItem: (name: string) => {
        const sessionData = sessionStorage.getItem(name);
        if (sessionData) {
            return JSON.parse(sessionData);
        }

        const localData = localStorage.getItem(name);
        if (localData) {
            return JSON.parse(localData);
        }

        return null;
    },
    setItem: (name: string, value: unknown) => {
        const serializedValue = JSON.stringify(value);
        sessionStorage.setItem(name, serializedValue);
        localStorage.setItem(name, serializedValue);
    },
    removeItem: (name: string) => {
        sessionStorage.removeItem(name);
        localStorage.removeItem(name);
    },
});

interface WorkspaceProjectState {
    workspace: WorkspaceView | null;
    project: ProjectView | null;
    siteId: string | null;
    /** workspace별 마지막 선택 프로젝트 기억 */
    projectMap: Record<string, ProjectView>;
    setWorkspace: (workspace: WorkspaceView | null) => void;
    setProject: (project: ProjectView | null) => void;
    setSiteId: (siteId: string | null) => void;
    getLastProject: (workspaceId: string) => ProjectView | undefined;
    clearSelection: () => void;
}

export const useSelectedStore = create<WorkspaceProjectState>()(
    persist(
        (set, get) => ({
            workspace: null,
            project: null,
            siteId: null,
            projectMap: {},
            setWorkspace: workspace => set({ workspace }),
            setProject: project => {
                const { workspace, projectMap } = get();
                if (project && workspace?.id) {
                    set({ project, projectMap: { ...projectMap, [workspace.id]: project } });
                } else {
                    set({ project });
                }
            },
            setSiteId: siteId => set({ siteId }),
            getLastProject: (workspaceId: string) => get().projectMap[workspaceId],
            clearSelection: () => set({ workspace: null, project: null }),
        }),
        {
            name: 'workspace-project-selection',
            storage: createDualStorage(),
        }
    )
);
